import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ChangePasswordModal } from '../components/ChangePasswordModal'
import {
  actionCreators,
  IChangePasswordState,
  selectError,
  selectIsOpen,
  selectIsSaving,
  selectIsValid,
  selectNewPassword,
  selectOldPassword,
  selectVerifyPassword,
} from '../modules/changePassword'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IChangePasswordState & ICurrentUserState
  >({
    error: selectError(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
    isValid: selectIsValid(),
    newPassword: selectNewPassword(),
    oldPassword: selectOldPassword(),
    user: selectCurrentUser(),
    verifyPassword: selectVerifyPassword(),
  }),
  actionCreators,
)(ChangePasswordModal)
